module.exports = __webpack_public_path__ + "static/media/life-after.8bf31d62.png";